module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_008.png
// module id = 1132
// module chunks = 0